import $http from "../axios";
import rewardProgramHistoryExample from "../assets/js/rewardProgramHistoryExample";

const state = {
  history: []
};

const getters = {
  rewardProgramHistory: state => {
    return state.history;
  }
};

const actions = {
  getRewardProgramHistory({ commit }, { useMock = false } = {}) {
    if (useMock) {
      commit("SET_REWARD_PROGRAM_HISTORY", {
        history: rewardProgramHistoryExample
      });

      return Promise.resolve({
        data: {
          result: "ok",
          payload: {
            history: rewardProgramHistoryExample
          }
        }
      });
    }

    return new Promise((resolve, reject) => {
      $http
        .get("get-reward-program-history")
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_REWARD_PROGRAM_HISTORY", res.data.payload);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  clearRewardProgramHistory({ commit }) {
    commit("CLEAR_REWARD_PROGRAM_HISTORY");
  }
};

const mutations = {
  SET_REWARD_PROGRAM_HISTORY(state, payload) {
    state.history = payload.history || [];
  },

  CLEAR_REWARD_PROGRAM_HISTORY(state) {
    state.history = [];
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
